<script>
    import EmojiConvertor from "emoji-js/lib/emoji.js";
    export let name;
    export let symbol;
    export let scale = 1;
    export let grayscale = false;

    $: fontSize = scale * 16;

    $: style = (() => {
        return `font-size: ${fontSize}px;`;
    })()

    // https://github.com/iamcal/js-emoji
    $: rendered = symbol || new EmojiConvertor().replace_colons(`:${name}:`);
</script>

<span class="emoji" class:grayscale {style}>
    {@html rendered}
</span>

<style>
    .emoji.grayscale {
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
    }
</style>